import { documentsQueryKeys } from '@src/documents/queryKeys';
import { DocumentsClient } from '@src/documents/services/DocumentsClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useShowDocumentToClient = ({
  orderId,
}: { orderId?: string } = {}) => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: async (data: { documentId: string; showToClient: boolean }) => {
      await DocumentsClient.markToShowToClient(
        data.documentId,
        data.showToClient,
      );
      return data.documentId;
    },
    onSuccess: async () => {
      if (orderId) {
        await queryClient.invalidateQueries({
          queryKey: documentsQueryKeys.byOrderId(orderId),
        });
      }
    },
  });

  return {
    markToShowToClient: mutate,
    isPending,
  };
};
